<template>
  <div class="footer">
    <div class="footer_body">
      <div class="footer-wrapper">
        <img class="footer_logo" src="@/assets/images/footer_logo_notext.png" alt="" />
        <nav class="nav">
          <div v-for="cloumn in navData" :key="cloumn.label" class="nav-column">
            <div
              class="nav-column_title wow animate__animated animate__fadeInUp"
            >
              {{ cloumn.label }}
            </div>
            <div class="nav-column_body">
              <template v-for="navItem in cloumn.children" :key="navItem.label">
                <a
                  class="nav-item_link wow animate__animated animate__fadeInUp"
                  :href="navItem.path"
                  v-if="navItem.type === 'link'"
                  target="_blank"
                >
                  {{ navItem.label }}
                </a>

                <RouterLink
                  v-else
                  class="nav-item_link wow animate__animated animate__fadeInUp"
                  :to="navItem.path"
                >
                  {{ navItem.label }}
                </RouterLink>
              </template>
            </div>
          </div>
        </nav>
        <div class="contact-qrcode_list">
          <div
            v-for="contactQrcode in contactQrcodeData"
            :key="contactQrcode.label"
            class="contact-qrcode_list-item wow animate__animated animate__fadeInUp"
          >
            <img :src="contactQrcode.imgPath.toString()" alt="" />
            <label>{{ contactQrcode.label }}</label>
          </div>
        </div>
      </div>
      <p class="address">
        地址：北京市朝阳区将台乡酒仙桥北路乙10号院2号楼星地中心B座10层1005室
      </p>
      <div class="webseit-info wow animate__animated animate__fadeInUp">
        <div class="copyright wow animate__animated animate__fadeInUp">
          版权所有©2019 Kattgatt，Inc。保留所有权利。<a
            href="https://beian.miit.gov.cn/"
            target="_blank"
          >
            京ICP备2023010658号
          </a>
        </div>
        <a
          class="webseit-beian"
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502053531"
        >
          <img
            src="@/assets/police-insignia.jpg"
            style="float: left; height: 100%"
          />
          <p style="">京公网安备 11010502053531号</p>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive } from "vue";
const navData = reactive([
  {
    label: "首页",
    children: [
      {
        label: "北京总部",
        path: "/homePage",
        type: "route",
      },
      {
        label: "企业超算一体机",
        path: "/homePage",
        type: "route",
      },
      {
        label: "家庭超算一体机",
        path: "/homePage",
        type: "route",
      },
      {
        label: "视频中心",
        path: "/homePage",
        type: "route",
      },
    ],
  },
  {
    label: "超算一体机",
    children: [
      {
        label: "AI营销超算一体机",
        path: "/superComputing",
        type: "route",
      },
      {
        label: "AI专利超算一体机",
        path: "/superComputing",
        type: "route",
      },
      {
        label: "AI种草超算一体机",
        path: "/superComputing",
        type: "route",
      },
    ],
  },
  {
    label: "人工智能家",
    children: [
      {
        label: "AI管家服务",
        path: "/productCenter",
        type: "route",
      },
      {
        label: "AI健康服务",
        path: "/productCenter",
        type: "route",
      },
      {
        label: "AI教育服务",
        path: "/productCenter",
        type: "route",
      },
      {
        label: "AI娱乐服务",
        path: "/productCenter",
        type: "route",
      },
      {
        label: "AI物联网服务",
        path: "/productCenter",
        type: "route",
      },
    ],
  },
  {
    label: "公司介绍",
    children: [
      {
        label: "新闻资讯",
        path: "/about/newList",
        type: "route",
      },
      {
        label: "企业荣誉",
        path: "/about/companyIntroduce",
        type: "route",
      },
      {
        label: "加入我们",
        path: "/about/companyIntroduce",
        type: "route",
      },
      {
        label: "联系我们",
        path: "/about/companyIntroduce",
        type: "route",
      },
      {
        label: "CRM",
        path: "http://www.kattgatt.com:5001/",
        type: "link",
      },
      {
        label: "工具下载",
        path: "/Download",
      },
    ],
  },
]);
const contactInfoData = reactive([
  // "电话：(0755) 8273 5192",
  "电话：400 0256 889",
  "商务合作：136 5114 4947",
  "媒体合作：134 3926 0906",
  "联系地址：北京市朝阳区将台乡酒仙桥北路乙10号院2号楼星地中心B座10层1005室",
  "公司名称：北京卡特加特人工智能科技有限公司",
]);

const contactQrcodeData = reactive([
  {
    imgPath: new URL("@/assets/images/image.png", import.meta.url).href,
    label: "公众号",
  },
  {
    imgPath: new URL("@/assets/images/WechatIMG23.jpg", import.meta.url),
    label: "APP下载",
  },
  // {
  //   imgPath: new URL("@/assets/images/android.png", import.meta.url),
  //   label: "安卓",
  // },
  // {
  //   imgPath: new URL("@/assets/images/android-pad.png", import.meta.url),
  //   label: "安卓平板",
  // },
]);
</script>

<style lang="scss" scoped>
.footer {
  background-color: $black_bg;

  .footer_body {
    width: transformRem($pc_min_width);
    padding-top: transformRem(70px);
    padding-bottom: transformRem(124px);
    color: #ffffff;
    margin: auto;
    .footer_text {
      width: 100%;
      text-align: center;
      h1 {
        margin-bottom: transformRem(10px);
        letter-spacing: transformRem(14px);
        font-weight: bold;
        font-size: transformRem(64px);
      }
    }

    .barkWiter {
      background: #ffffff;
      width: 100%;
      height: 50px;
      margin-bottom: 50px;
    }
  }
}

.nav {
  display: flex;
  flex-wrap: wrap;
  gap: transformRem(20px);

  .nav-column {
    flex: 1;

    .nav-column_title {
      margin-bottom: transformRem(24px);
      font-size: transformRem(20px);
      color: $white_font;
    }
  }

  @media screen and (max-width: 1400px) {
    .nav-column {
      width: 33.33%;
      text-align: center;
      margin-bottom: transformRem(48px);

      &:nth-of-type(1) {
        flex-grow: 1;
      }

      &:nth-of-type(6) {
        flex-grow: 1;
      }

      .nav-item_link {
        width: auto;
      }
    }
  }

  .nav-item_link {
    display: block;
    width: max-content;
    margin-bottom: 10px;
    color: $gray_normal_font;

    &:hover {
      color: $white_font;
    }
  }
}

.contact {
  margin-bottom: transformRem(60px);

  .contact_body {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .contact-info_title {
      font-size: transformRem(20px);
      color: $white_font;
    }

    .contact-info_item {
      color: $gray_normal_font;
    }
  }
}

.webseit-info {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  color: $gray_normal_font;
  padding: transformRem(12px) 0;
}

@media screen and (max-width: 1400px) {
  .footer {
    .footer_body {
      padding-top: transformRem(70px);
      padding-bottom: transformRem(124px);
      padding-left: 16px;
      padding-right: 16px;
      width: transformRem($h5_min_width);
      .footer_text {
        width: 100%;
        text-align: center;
        h1 {
          margin-bottom: transformRem(10px);
          letter-spacing: transformRem(14px);
          font-weight: bold;
          font-size: transformRem(64px);
        }
      }

      .barkWiter {
        background: #ffffff;
        width: 100%;
        height: 50px;
        margin-bottom: 50px;
      }
    }
  }

  .contact {
    .contact_body {
      .contact-qrcode_list {
        margin: 0 -16px;

        .contact-qrcode_list-item {
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;
          align-items: center;

          width: 50%;
          margin: 0px;
          padding: 16px;

          img {
            width: 100%;
          }
        }
      }
    }
  }
}

.footer-wrapper {
  display: flex;
  justify-content: space-between;
  margin-bottom: transformRem(54px);
}
.footer_logo {
  width: transformRem(200px);
  height: transformRem(63px);
  margin-right: transformRem(100px);
}
.nav {
  flex: 1;
  margin-right: transformRem(40px);
}

.contact-qrcode_list {
  display: flex;
  flex-wrap: wrap;
  justify-content: right;

  .contact-qrcode_list-item {
    margin-left: transformRem(12px);
    text-align: center;
    color: $gray_normal_font;
    img {
      width: transformRem(104px);
    }

    img,
    lable {
      display: block;
      margin-bottom: transformRem(16px);
    }
  }
}

.webseit-beian {
  display: flex;
  p {
    margin: 0;
    margin-left: transformRem(10px);
  }
}
.address {
  font-size: transformRem(16px);
  color: $gray_normal_font;
  margin-bottom: transformRem(20px);
}
</style>
